/* eslint-disable react/forbid-dom-props */
import { yupResolver } from '@hookform/resolvers/yup';
import type { FC } from 'react';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { Checkbox, FormInput } from '@catalyze/ui';
import type { IAccountDetailsForm } from 'features/SignUp/types/signUpForm';
import { STEP_COUNT } from 'features/SignUp/types/signUpForm';
import { accountDetailsSchema } from 'schemas/signUpForm';

import { FormLine, InputContainer, ButtonsContainer } from './styled';

// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { CheckboxContainer } from '../../../../../../../../libs/ui/src/components/Card/styled';
import { StyledForm } from '../../Form';
import { StyledFormButton } from '../../FormButton';
import { FormTitle } from '../../FormTitle';
import { ProgressBar } from '../../ProgressBar';
import { Spacer } from '../DocusSignForm/styled';

interface IAccountDetailsFormProps {
    initialValues: IAccountDetailsForm | undefined;
    onSubmit: (data: IAccountDetailsForm) => void;
    onGoBack: (data: IAccountDetailsForm) => void;
}

export const AccountDetailsForm: FC<IAccountDetailsFormProps> = ({
    initialValues,
    onSubmit,
    onGoBack,
}) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const [checkBoxValue, setCheckboxValue] = useState(false);
    const formMethods = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(accountDetailsSchema),
    });
    const { getValues, handleSubmit } = formMethods;

    return (
        <>
            <ProgressBar progress={(2 / STEP_COUNT) * 100} />
            <FormTitle
                goBack={() => onGoBack(getValues())}
                title="Account details"
                subtitle="Enter your basic information."
            />
            <FormProvider {...formMethods}>
                <StyledForm onSubmit={handleSubmit(onSubmit)}>
                    <FormLine>
                        <InputContainer>
                            <FormInput id="firstName" label="First Name" />
                        </InputContainer>
                        <InputContainer>
                            <FormInput id="lastName" label="Last Name" />
                        </InputContainer>
                    </FormLine>
                    <FormLine>
                        <InputContainer>
                            <CheckboxContainer>
                                <Checkbox
                                    checked={checkBoxValue}
                                    handleOnChange={(checked) => {
                                        setCheckboxValue(checked);
                                    }}
                                    uniqueKey="termsconditions"
                                />
                                <p style={{ fontSize: 14 }}>
                                    I agree to the{' '}
                                    <a
                                        href="https://www.catalyzeai.com/terms"
                                        target="_BLANK"
                                        rel="noreferrer"
                                    >
                                        terms and conditions
                                    </a>
                                </p>
                            </CheckboxContainer>
                        </InputContainer>
                    </FormLine>
                    <br />
                    <Spacer />
                    <ButtonsContainer>
                        <StyledFormButton
                            disabled={!checkBoxValue}
                            type="submit"
                        >
                            Next
                        </StyledFormButton>
                    </ButtonsContainer>
                </StyledForm>
            </FormProvider>
        </>
    );
};
